// CSS class names -- prefixed with 'dv-' to avoid collsions with external CSS

export default {
  // Chart types
  line_chart: 'dv-line-chart',

  // Chart states
  chart_zoomed: 'dv-zoomed',
  chart_panning: 'dv-panning',
  chart_viewport_hover: 'dv-viewport-hover',

  // Header
  header: 'dv-header',
  title: 'dv-title',
  subtitle: 'dv-subtitle',

  // Legend
  legend: 'dv-legend',
  legend_item: 'dv-legend-item',

  // Plot area
  plot_area: 'dv-plot-area',
  plot_bg: 'dv-plot-background',
  viewport: 'dv-viewport',

  // Lines
  lines_group: 'dv-lines-group',
  line: 'dv-line',
  point: 'dv-point',
  point_label: 'dv-point-label',
  point_label_line: 'dv-point-label-line',
  annotation: 'dv-annotation',
  annotation_bg: 'dv-annotation-bg',

  // Axes
  x_axis: 'dv-x-axis',
  y_axis: 'dv-y-axis',
  axis_line: 'dv-axis-line',
  axis_at_zero: 'dv-axis-at-zero',

  // Grid/ticks
  tick: 'dv-tick',
  grid_line: 'dv-grid-line',
  x_axis_grid_lines: 'dv-grid-lines-v',
  y_axis_grid_lines: 'dv-grid-lines-h',

  // Footer
  footer: 'dv-footer',
  footnote: 'dv-footnote',
  source: 'dv-source',

  // Tooltips
  tooltip: 'dv-tooltip',
  tooltip_left: 'dv-tooltip-left',
  tooltip_right: 'dv-tooltip-right',
  group_tooltip: 'dv-group-tooltip',
  tooltip_label: 'dv-tooltip-label',
  tooltip_value: 'dv-tooltip-value',
  tooltip_line_label: 'dv-tooltip-line-label',
  tooltip_hidden: 'dv-hidden',
  tooltip_point: 'dv-tooltip-point',

  // Label editor
  label_editor: 'dv-label-editor',
  label_editor_closing: 'dv-editor-closing',
  selected_point: 'dv-selected-point',
  label_handle: 'dv-label-handle',

  // Other
  placeholder: 'dv-placeholder',
  no_select: 'dv-no-select',
};
